import { AccelerationCurve, EasingType } from "./accelerationCurve";

type LinearInterpolator<T> = (a: T, b: T, t: number) => T;

export class Transition<T> {
    private _accelerationCurve: AccelerationCurve;
    private _interpolator: LinearInterpolator<T>;
    private _currentTime: number;

    constructor(public start: T, public target: T, public duration: number, easing: EasingType, interpolator: LinearInterpolator<T>) {
        this._accelerationCurve = new AccelerationCurve(easing);
        this._interpolator = interpolator;
        this._currentTime = 0;
    }

    get currentTime(): number {
        return this._currentTime;
    }

    get currentValue(): T {
        return this.getValueForTime(this._currentTime);
    }

    getValueForTime(time: number): T {
        let percent = this.duration > 0 ? Math.min(Math.max(time / this.duration, 0), 1) : 1;
        let t = this._accelerationCurve.getValue(percent);
        return this._interpolator(this.start, this.target, t);
    }

    updateWithElapsedTime(deltaTime: number): T {
        this._currentTime += deltaTime;
        return this.currentValue;
    }

    resetWithNewTarget(newTarget: T) {
        this.start = this.currentValue;
        this.target = newTarget;
        this._currentTime = 0;
    }
}

export class NumberTransition extends Transition<number> {
    constructor(start: number, target: number, duration: number, easing: EasingType) {
        super(start, target, duration, easing, (a, b, t) => a + t * (b - a));
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/transition.ts